import { BaseStore } from 'fluxible/addons';

export default class LanguageStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.language = null;
    }

    init(language) {
        this.language = language;
    }

    getLanguage() {
        return this.language;
    }
}
LanguageStore.storeName = 'LanguageStore';



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/language-store.js